import { useEffect, useState } from 'react'
import { useTheme } from '../../../theme'
import { chercherEntreprise } from '../../../hooks/useDossierExposant'
import { classeChamp } from '../champs'
import { ORANGE, ROUGE, TEAL, VERT, teinte } from './dossierUi'

const formaterSiret = (s) => (s || '').replace(/^(\d{3})(\d{3})(\d{3})(\d{5})$/, '$1 $2 $3 $4')

/**
 * « Retrouver mon SIRET » (S74, retour Enzo) : on tape le NOM de sa structure,
 * le registre public des entreprises (INSEE) propose les correspondances, un
 * appui remplit le SIRET. La saisie manuelle au-dessus reste possible.
 */
function RechercheEntreprise({ onChoisir }) {
  const { isWeb3 } = useTheme()
  const [ouvert, setOuvert] = useState(false)
  const [q, setQ] = useState('')
  const [resultats, setResultats] = useState(null) // null = rien cherche
  const [charge, setCharge] = useState(false)
  const [erreur, setErreur] = useState(null)

  // Recherche 400 ms apres la derniere frappe ; seule la derniere reponse compte.
  useEffect(() => {
    const texte = q.trim()
    if (texte.length < 3) { setResultats(null); setErreur(null); return undefined }
    let vivant = true
    const t = setTimeout(() => {
      setCharge(true)
      chercherEntreprise(texte)
        .then((r) => { if (vivant) { setResultats(r); setErreur(null) } })
        .catch(() => { if (vivant) { setResultats(null); setErreur("Le registre ne répond pas pour l'instant — saisissez votre SIRET à la main.") } })
        .finally(() => { if (vivant) setCharge(false) })
    }, 400)
    return () => { vivant = false; clearTimeout(t) }
  }, [q])

  if (!ouvert) {
    return (
      <button onClick={() => setOuvert(true)} className="mt-2.5 text-[12.5px] font-bold" style={{ color: ORANGE }}>
        🔎 Vous ne l'avez pas sous la main ? Retrouvez-le avec le nom de votre structure ›
      </button>
    )
  }

  return (
    <div className="mt-3">
      <label htmlFor="dossier-registre" className="block text-[11px] font-bold mb-1.5" style={{ color: 'rgba(7,62,61,0.5)' }}>
        Nom de votre entreprise, exploitation ou association
      </label>
      <input id="dossier-registre" value={q} onChange={(e) => setQ(e.target.value)} autoFocus
        placeholder="Ex. : Ferme Bèlè, Jean Bèlè…" className={classeChamp(isWeb3)} />
      {charge && <p className="text-[11.5px] mt-2" style={{ color: 'rgba(7,62,61,0.5)' }}>Recherche…</p>}
      {erreur && <p className="text-[11.5px] mt-2" style={{ color: ROUGE }}>{erreur}</p>}
      {resultats && !charge && resultats.length === 0 && (
        <p className="text-[11.5px] mt-2 leading-relaxed" style={{ color: 'rgba(7,62,61,0.6)' }}>
          Aucune structure trouvée. Essayez le nom qui figure sur votre Kbis, ou votre nom et prénom pour une entreprise individuelle.
        </p>
      )}
      {resultats?.length > 0 && (
        <div className="mt-2 flex flex-col gap-1.5">
          {resultats.map((r) => (
            // Une structure fermee s'affiche (on comprend pourquoi on ne la retrouve
            // pas active) mais ne se choisit pas.
            <button key={`${r.siren}-${r.siret}`} onClick={() => onChoisir(r.siret || r.siren)} disabled={!r.active}
              className={`rounded-[14px] text-left w-full flex items-start gap-2.5 ${r.active ? '' : 'opacity-60'}`}
              style={{ padding: '10px 12px', background: 'rgba(255,255,255,0.6)', border: '1px solid rgba(7,62,61,0.1)' }}>
              <div className="flex-1 min-w-0">
                <p className="text-[13px] font-bold truncate" style={{ color: VERT }}>{r.nom}</p>
                <p className="text-[11px] truncate" style={{ color: 'rgba(7,62,61,0.55)' }}>
                  {[r.commune, formaterSiret(r.siret) || r.siren].filter(Boolean).join(' · ')}
                </p>
              </div>
              {r.active ? (
                <span className="text-[11px] font-extrabold rounded-full flex-shrink-0" style={{ color: VERT, background: teinte(TEAL, 0.15), padding: '4px 9px' }}>Choisir</span>
              ) : (
                <span className="text-[10.5px] font-bold rounded-full flex-shrink-0" style={{ color: ROUGE, background: 'rgba(217,83,79,0.1)', padding: '4px 9px' }}>Fermée</span>
              )}
            </button>
          ))}
        </div>
      )}
      <p className="text-[10.5px] mt-2 leading-relaxed" style={{ color: 'rgba(7,62,61,0.45)' }}>
        Source : registre public des entreprises (INSEE, annuaire-entreprises.data.gouv.fr).
      </p>
    </div>
  )
}

export default RechercheEntreprise
